export const xxsmall = '2px';
export const xsmall = '5px';
export const small = '10px';
export const medium = '20px';
export const large = '30px';
export const xlarge = '40px';
export const xxlarge = '50px';
export const xxxlarge = '80px';
export default {
  xxsmall,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  xxlarge,
  xxxlarge
};